(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('redirectParamsService', redirectParamsService);

	redirectParamsService.$inject = [];

	function redirectParamsService() {
		var redirectParams = {};
    
		return {
			putRedirectParams: putRedirectParams,
			popRedirectParams: popRedirectParams,
			hasRedirectParams: hasRedirectParams
		};
    
		function putRedirectParams(params) {
			redirectParams = params;
		}

		function popRedirectParams() {
			var params = redirectParams;
			redirectParams = {};
			return params;
		}

		function hasRedirectParams() {
			return Object.keys(redirectParams).length > 0;
		}
	}
})();
